export default {
      id: "Icon--socialShare-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--socialShare",
      toString: function () {
        return this.url;
      }
    }